const BASE_URL = process.env.REACT_APP_ZVB_URL;

// Authentication and login API 

// Function to return the Authorization header in Bearer format
const getAuthHeader = () => {
  const token = localStorage.getItem("authToken");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Function to attach authentication header 
const authenticatedFetch = async (url, options = {}) => {
  const headers = {
    Accept: "application/json",
    ...getAuthHeader(),
    ...options.headers,
  };

  if (!(options.body instanceof FormData)) {
    headers["Content-Type"] = "application/json";
  }

  return fetch(url, { ...options, headers });
};

// API to login 
export const login = async (email, password) => {
  try {
    const response = await fetch(`${BASE_URL}/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ email, password }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Login failed");
    }

    const data = await response.json();
    return data; // Should contain { user: {...}, token: "..." }
  } catch (error) {
    console.error("Login error:", error);
    throw error;
  }
};
// API to logout
export const logout = async () => {
  try {
    const response = await authenticatedFetch(`${BASE_URL}/logout`, {
      method: "POST",
    });

    if (!response.ok) {
      throw new Error(`Logout failed: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error logging out:", error);
    throw error;
  }
};


// Appointment API 

// API call to fetch all appointments
export const fetchAppointments = async (date) => {
  try {
    const response = await authenticatedFetch(
      `${BASE_URL}/appointments/${date}`
    );


    if (!response.ok) {
      throw new Error(`Network response error: ${response.status}`);
    }
    const res = await response.json();
    return res;
  } catch (error) {
    console.error("Error while fetching Appointment", error);
    return null;
  }
};

// Clients API 

// API to fetch all clients
export const fetchClients = async () => {
  try {
    const response = await authenticatedFetch(
      `${BASE_URL}/clients`
    );


    if (!response.ok) {
      throw new Error(`Network response error: ${response.status}`);
    }
    const res = await response.json();
    console.log(res);
    return res;
  } catch (error) {
    console.error("Error while fetching Clients", error);
    return null;
  }
};


// VEHICLE API
// API to fetch all vehicles
export const fetchVehicles = async () => {
  try {
    const response = await authenticatedFetch(
      `${BASE_URL}/vehicles`
    );


    if (!response.ok) {
      throw new Error(`Network response error: ${response.status}`);
    }
    const res = await response.json();
    console.log(res);
    return res;
  } catch (error) {
    console.error("Error while fetching Vehicles", error);
    return null;
  }
};

// API to fetch vehicle details
export const fetchVehicleMaintenanceRecords = async (vehicleId) => {
  const response = await authenticatedFetch(`${BASE_URL}/vehicles/${vehicleId}/maintenance-record`, {
    method: "GET",
    headers: {
      Accept: "application/json",
    },
  });

  if (!response.ok) {
    throw new Error("Failed to fetch vehicle maintenance records");
  }

  return response.json(); // returns { success, data }
};


export const fetchVehiclesByPhone = async (phone) => {
  try {
    const response = await authenticatedFetch(
      `${BASE_URL}/getVehiclesByPhone?phone=${encodeURIComponent(phone)}`,
      {
        method: "GET",
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }

    return await response.json();
  } catch (err) {
    console.log("Error: Could not fetch vehicle records because:", err);
    return null;
  }
};

// Services API 

// API to fetch Services

export const fetchServices = async () => {
  try {
    const response = await authenticatedFetch(`${BASE_URL}/services`);

    if (!response.ok) {
      throw new Error("Network response error.");
    }

    const data = await response.json();


    console.log("Fetched services data:", data);

    return Array.isArray(data) ? data : [];
  } catch (error) {
    console.error("Error fetching services:", error);
    return [];
  }
};






// API for Manage Quotes 

// API to fetch all quotes
export const fetchQuotes = async () => {
  try {
    const response = await authenticatedFetch(
      `${BASE_URL}/fetchQuote`
    );


    if (!response.ok) {
      throw new Error(`Network response error: ${response.status}`);
    }
    const res = await response.json();
    console.log(res);
    return res;
  } catch (error) {
    console.error("Error while fetching Quotess", error);
    return null;
  }
};

// API to Mark a quote as complete

export const completeQuote = async (quoteId) => {
  try {
    // const response = await fetch(`${BASE_URL}/completeQuote`, {
    //   method: "PATCH",
    //   headers: {
    //     "Content-Type": "application/json",
    //     ...getAuthHeader(),
    //   },
    //   body: JSON.stringify({ quoteId }),
    // });

    // if (!response.ok) {
    //   throw new Error(`HTTP ${response.status}`);
    // }

    // const data = await response.json();
    // return data;

  } catch (error) {
    console.error("Error completing quote:", error);
    return null;
  }
};

// API to Request Inspection

export const requestInspection = async (data) => {

  try {
    //const token = localStorage.getItem("authToken");

    // Uncomment This part to make the API workkks

    // const response = await fetch(`${BASE_URL}/requestInspection`, {
    //   method: "POST",
    //   headers: {
    //     "Content-Type": "application/json",
    //     ...getAuthHeader(),
    //   },
    //   body: JSON.stringify({
    //     id,
    //     quoteReference,
    //     status,
    //     description,

    //     customer: {
    //       name,
    //       phone,
    //       email,
    //     },

    //     vehicle: {
    //       year,
    //       make,
    //       model,
    //     },
    //   }),
    // });

    // if (!response.ok) {
    //   throw new Error(`HTTP ${response.status}`);
    // }
    // return await response.json();

    // console.log("Data received: ", data)

  } catch (error) {
    console.error("Error requesting inspection:", error);
    return null;
  }
};


// API to send Quote to the customer 

export const sendQuote = async ({
  quoteId,
  quoteReference,
  customer,
  vehicle,
  vehicleText,
  message = "",
  file,
}) => {
  try {
    const formData = new FormData();

    formData.append("quoteId", quoteId);
    formData.append("quoteReference", quoteReference);
    formData.append("customer", JSON.stringify(customer));
    formData.append("vehicle", JSON.stringify(vehicle));
    formData.append("vehicleText", vehicleText);
    formData.append("message", message);
    formData.append("file", file);

    // const response = await fetch(`${BASE_URL}/send-quote`, {
    //   method: "POST",
    //   headers: {
    //     ...getAuthHeader(),
    //   },
    //   body: formData,
    // });

    // if (!response.ok) {
    //   throw new Error(`HTTP ${response.status}`);
    // }

    // return await response.json();

    // uncomment above lines to work code

    console.log("Form Data: ", formData)

    for (let pair of formData.entries()) {
      console.log(pair[0], pair[1]);
    }
  } catch (error) {
    console.error("Error sending quote:", error);
    return null;
  }
};
